import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { SessionService } from './session.service';

import { ERRORS_SESSION_TIMEOUT } from '@app/infrastructure/constants';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  constructor(private router: Router, private sessionService: SessionService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.indexOf('sessions') >= 0) {
      return next.handle(req);
    }

    return this.sessionService.getSession().pipe(
      mergeMap((sessionId) => {
        if (sessionId) {
          req = req.clone({
            setHeaders: {
              sessionId,
            },
          });
        }
        return next.handle(req);
      }),
      catchError((err) => {
        const url = req.url.toLowerCase();
        if (
          url.indexOf('saveandquotechange') >= 0 ||
          url.toLowerCase().indexOf('updatequotedcahnge') >= 0
        ) {
          return throwError(err);
        }

        const { status, error } = err;
        if (
          status === 404 &&
          error.errorMessage &&
          error.errorMessage.toLowerCase() === 'session not found'
        ) {
          this.router.navigate([ERRORS_SESSION_TIMEOUT]);
          return of({} as HttpEvent<any>);
        }
        return throwError(err);
      })
    );
  }
}
